import { render, staticRenderFns } from "./ProveedoresForm.vue?vue&type=template&id=4da0e1d8"
import script from "./ProveedoresForm.vue?vue&type=script&lang=js"
export * from "./ProveedoresForm.vue?vue&type=script&lang=js"
import style0 from "./ProveedoresForm.vue?vue&type=style&index=0&id=4da0e1d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports